export function deleteUnnecessaryProperties<S>(listDto: S): S {
  const _listDto: any = { ...listDto };
  Object.keys(_listDto).forEach(
    (key) => (_listDto[key] === undefined || _listDto[key] === null) && delete _listDto[key],
  );
  return _listDto;
}
